import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import MuSwitch from 'material-ui/Switch';
import { FormControl, FormControlLabel, FormHelperText } from 'material-ui/Form';

const styles = theme => ({
  root: { }
});

export class Switch extends Component {
  render() {
    const {
      classes,
      label,
      trueLabel,
      falseLabel,
      input,
      meta,
      helper
    } = this.props;
    const { error, warning, dirty } = meta;

    const hasError = dirty && ( error || warning );
    const helperText = hasError ? ( error || warning ) : helper;
    const switchLabel = label || input.value ? trueLabel : falseLabel;

    return (
      <FormControl component="fieldset" className={classes.root}>
        <FormControlLabel
          control={
            <MuSwitch
              className={classes.textFeild}
              value={input.name}
              checked={input.value}
              onChange={input.onChange}
              onBlur={input.onBlur}
            />
          }
          label={switchLabel}
        />
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    );
  }
}

Switch.defaultProps = {
}

Switch.propTypes = {
  classes: PropTypes.object.isRequired,
  label:   PropTypes.string,
  legend:  PropTypes.string,
  input:   PropTypes.object.isRequired,
}

export default withStyles(styles)(Switch);



// WEBPACK FOOTER //
// ./src/components/common/formComponents/Switch.js